export const Profile = (props)=>{
    return (
        <div>
            Profile
        </div>
    )
}